import React from 'react';
import { Text } from '@amzn/storm-ui';
import { ButtonAction } from '@amzn/storm-ui-page-header';
import { ACTION_STATE, BUTTON_TYPE, ButtonType } from '../types';
import { mapButtonTypeToStormButtonVariant } from 'src/features/header/components/PageHeader/utils';

export const ActionsButton: React.VFC<ButtonType> = ({
  buttonType,
  state,
  id,
  label,
  toolTip,
  tooltipPosition,
  ariaLabel,
  onClickEvent,
  isNonInteractiveTooltip,
}) => {
  return (
    <ButtonAction
      id={id}
      label={label}
      variant={mapButtonTypeToStormButtonVariant(
        buttonType ?? BUTTON_TYPE.NORMAL,
      )}
      {...(toolTip?.length && {
        tooltipContent: <Text>{toolTip}</Text>,
        tooltipPosition: tooltipPosition,
        'aria-haspopup': true,
      })}
      nonInteractiveTooltip={isNonInteractiveTooltip}
      onClick={onClickEvent}
      disabled={state === ACTION_STATE.DISABLED}
      loading={state === ACTION_STATE.LOADING}
      data-eventid={id}
      data-ccx-e2e-id={`aac-action-${id}`}
      aria-label={ariaLabel}
    />
  );
};
